import { useEffect, } from "react";
import "./dashboardview.scss";
import { Card } from "react-bootstrap";

const Dashboard = () => {

    useEffect(() => {
    }, []);


    return (
        <>
            <Card className="p-4 mt-3">

                <h1>Dashboard</h1>
            </Card >

        </>
    )
}

export default Dashboard;